export const alertConstant = {
  DEFAULTERR: 'sorry unable to process! please try again later',
  NOTIFICATIONSUCCESS: 'NOTIFICATION_SUCCESS',
  NOTIFICATIONCLEAR: 'NOTIFICATION_CLEAR',
};
